import { User } from "@one-profile/core";
import { useFeatureToggle } from "./useFeatureToggle";

type Feature = "dashboard" | "deviceSecurity";

import { Environment } from "../config/backendUrl";
import { getEnv } from "../config/environment";
import { FeatureToggle } from "../services/getFeatureToggleConfig";
import { useContext } from "react";
import { appContext } from "../context/AppContext";
import { useAccountTeamMembersQuery } from "@mytw/account-frontend-api";
import { defaultContext } from "@tanstack/react-query";

export const devTeamIds = [
  "27763",
  "26532",
  "31467",
  "35535",
  "33726",
  "26002",
  "38816",
  "27436",
  "23984",
  "35999",
  "33834",
  "12366", // Pei Ren,
  "35476",
  "23206",
  "23562",
  "29869",
  "44589",
  "39082"
];
const ttClts = ["10407", "17204", "23984", "18594"];
const testingGroup = ["25719", "25967", "39135", "27081", "19150"];
const accountSteeringGroup = [
  "10013",
  "33654",
  "17204",
  "20694",
  "13396",
  "11869",
  "22582",
];

export function isInternalTeamMember(empId: string): boolean {
  return (
    devTeamIds.includes(empId) ||
    ttClts.includes(empId) ||
    accountSteeringGroup.includes(empId) ||
    testingGroup.includes(empId)
  );
}

const featureFlag: Record<
  Environment,
  Record<Feature, (user: User) => boolean>
> = {
  dev: {
    dashboard: (user) => isInternalTeamMember(user.employeeNumber),
    deviceSecurity: (_user) => true,
  },
  stage: {
    dashboard: (user) => isInternalTeamMember(user.employeeNumber),
    deviceSecurity: (_user) => true,
  },
  prod: {
    dashboard: (user) => isInternalTeamMember(user.employeeNumber),
    deviceSecurity: (_user) => true,
  },
};

export function useCheckAccess(feature: Feature, user: User) {
  const featureToggle = useFeatureToggle();
  const context = useContext(appContext);
  const query = useAccountTeamMembersQuery({
    accountId: context.appConfig.accountId,
    queryContext: defaultContext,
    getAccessToken: context.getAccessToken,
  });

  return (
    isFeatureEnableForUser(feature, user) ||
    isDashboardFeatureEnableForAccount(query.data?.name, featureToggle)
  );
}

export function isFeatureEnableForUser(feature: Feature, user: User) {
  return featureFlag[getEnv()][feature](user);
}

export function isDashboardFeatureEnableForAccount(
  accountName: string,
  featureToggle: any
) {
  if (isConfigReady()) {
    return isFeatureEnable(featureToggle.data);
  }
  return false;

  function isConfigReady() {
    return featureToggle.data;
  }

  function isFeatureEnable(featureToggle: FeatureToggle) {
    if (featureToggle.accountsForKpiDashboard) {
      return featureToggle.accountsForKpiDashboard?.includes(accountName);
    }
    return true;
  }
}
